import styled, { css } from 'styled-components';
import { stateInteraction, transition, fontSize, boxShadow } from '../../mixins';
import { colorStyle } from '../Link/Link.style';
import { darken, rem, hideVisually } from 'polished';
export var StyledFlexContainer = styled.div.withConfig({
  displayName: "Buttonstyle__StyledFlexContainer",
  componentId: "sc-1vu4swu-0"
})(["display:flex;justify-content:center;align-items:center;flex-direction:", ";"], function (_ref) {
  var iconToRight = _ref.iconToRight;
  return iconToRight ? 'row-reverse' : 'row';
});
export var StyledIconContainer = styled.div.withConfig({
  displayName: "Buttonstyle__StyledIconContainer",
  componentId: "sc-1vu4swu-1"
})(["display:inline-flex;padding-right:", ";padding-left:", ";visibility:", ";"], function (_ref2) {
  var iconToRight = _ref2.iconToRight,
      theme = _ref2.theme;
  return iconToRight ? '0' : "".concat(theme.spaces.xs);
}, function (_ref3) {
  var iconToRight = _ref3.iconToRight,
      theme = _ref3.theme;
  return iconToRight ? "".concat(theme.spaces.xs) : '0';
}, function (_ref4) {
  var isLoading = _ref4.isLoading;
  return isLoading ? 'hidden' : 'visible';
});
export var StyledLoadingContainer = styled.div.withConfig({
  displayName: "Buttonstyle__StyledLoadingContainer",
  componentId: "sc-1vu4swu-2"
})(["position:absolute;margin:0 auto;display:inline-block;"]);
export var StyledButton = styled.button.withConfig({
  displayName: "Buttonstyle__StyledButton",
  componentId: "sc-1vu4swu-3"
})(["", ";", ";border:2px solid transparent;border-radius:", ";box-sizing:border-box;font-family:", ";box-shadow:none;color:", ";font-weight:", ";min-width:", ";vertical-align:middle;cursor:pointer;min-height:", ";&:hover,&:focus,&:active{text-decoration:underline;}", ";", ";", ";", ";", ";", ";", ""], transition(), function (_ref5) {
  var theme = _ref5.theme;
  return fontSize(theme.font.size.xs);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.radius;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.font.family.primary;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.color.white;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.font.weight.bold;
}, rem('128px'), function (_ref10) {
  var theme = _ref10.theme;
  return theme.spaces.xxlg;
}, primary, apply, secondary, alternate, disabledStyle, linkPaddingProp, function (_ref11) {
  var styledAsLink = _ref11.styledAsLink;
  return styledAsLink ? 'text-decoration: underline; background-color: transparent; border: none;' : '';
});
export var StyledHiddenLabel = styled.span.withConfig({
  displayName: "Buttonstyle__StyledHiddenLabel",
  componentId: "sc-1vu4swu-4"
})(["", ""], hideVisually());

function linkPaddingProp(_ref12) {
  var styledAsLink = _ref12.styledAsLink,
      linkPadding = _ref12.linkPadding,
      theme = _ref12.theme;

  if (styledAsLink) {
    return linkPadding ? "padding: ".concat(theme.spaces.xs, " ").concat(theme.spaces.md, ";") : 'min-width: 0;padding: 0;';
  } else {
    return "padding: ".concat(theme.spaces.xs, " ").concat(theme.spaces.md, ";");
  }
}

function primary(_ref13) {
  var variant = _ref13.variant,
      theme = _ref13.theme,
      disabled = _ref13.disabled,
      isLoading = _ref13.isLoading,
      isOnDarkBg = _ref13.isOnDarkBg,
      styledAsLink = _ref13.styledAsLink;
  var isPrimary = variant === 'primary' && !disabled;

  if (isPrimary) {
    if (styledAsLink) {
      return "\n        ".concat(colorStyle({
        theme: theme,
        isOnDarkBg: isOnDarkBg,
        tint: 'primary'
      }), "\n      ");
    }

    if (isLoading) {
      return isLoadingStyle(theme.color.primary, theme.color.white);
    } else {
      return css(["color:", ";svg{fill:", ";color:", ";}background-color:", ";", ";"], theme.color.white, theme.color.white, theme.color.white, theme.color.primary, stateInteraction(theme.color.primary));
    }
  }
}

function apply(_ref14) {
  var variant = _ref14.variant,
      theme = _ref14.theme,
      disabled = _ref14.disabled,
      isLoading = _ref14.isLoading,
      isOnDarkBg = _ref14.isOnDarkBg,
      styledAsLink = _ref14.styledAsLink;
  var isApply = variant === 'apply' && !disabled;

  if (isApply) {
    if (styledAsLink) {
      return "\n        ".concat(colorStyle({
        theme: theme,
        isOnDarkBg: isOnDarkBg,
        tint: 'black'
      }), "\n      ");
    }

    if (isLoading) {
      return isLoadingStyle(theme.color.emerald, theme.color.white);
    } else {
      return css(["color:", ";svg{fill:", ";color:", ";}background-color:", ";", ";"], theme.color.white, theme.color.white, theme.color.white, theme.color.emerald, stateInteraction(theme.color.emerald));
    }
  }
}

function secondary(_ref15) {
  var variant = _ref15.variant,
      theme = _ref15.theme,
      disabled = _ref15.disabled,
      isLoading = _ref15.isLoading,
      isOnDarkBg = _ref15.isOnDarkBg,
      styledAsLink = _ref15.styledAsLink;
  var isSecondary = variant === 'secondary' && !disabled;

  if (isSecondary) {
    if (styledAsLink) {
      return "\n        ".concat(colorStyle({
        theme: theme,
        isOnDarkBg: isOnDarkBg,
        tint: 'black'
      }), "\n      ");
    }

    if (isLoading) {
      return isLoadingStyle(theme.color.primary, theme.color.white);
    } else {
      return secondaryStyle(theme.color.primary, theme.color.white);
    }
  }
}

function alternate(_ref16) {
  var variant = _ref16.variant,
      theme = _ref16.theme,
      disabled = _ref16.disabled,
      isLoading = _ref16.isLoading,
      isOnDarkBg = _ref16.isOnDarkBg,
      styledAsLink = _ref16.styledAsLink;
  var isAlternate = variant === 'alternate' && !disabled;

  if (isAlternate) {
    if (styledAsLink) {
      return "\n        ".concat(colorStyle({
        theme: theme,
        isOnDarkBg: isOnDarkBg,
        tint: 'black'
      }), "\n      ");
    }

    if (isLoading) {
      return isLoadingStyle(theme.color.slate, theme.color.white);
    } else {
      return secondaryStyle(theme.color.slate, theme.color.white);
    }
  }
}

function secondaryStyle(baseColor, white) {
  return "\n    color: ".concat(baseColor, ";\n    background-color: ").concat(white, ";\n    border-color: ").concat(baseColor, ";\n    ").concat(stateInteraction(baseColor, true), ";\n    ").concat(StyledIconContainer, " {\n      svg {\n        ").concat(transition(), ";\n        fill: ").concat(baseColor, ";\n        color: ").concat(baseColor, ";\n      }\n    }\n    &:hover {\n      color: ").concat(white, ";\n      svg {\n        fill: ").concat(white, ";\n        color: ").concat(white, ";\n      }\n    }\n    &:focus {\n      color: ").concat(baseColor, ";\n      svg {\n        fill: ").concat(baseColor, ";\n        color: ").concat(baseColor, ";\n      }\n    }\n    &:active {\n      border-color: transparent;\n      color: ").concat(white, ";\n      svg {\n        fill: ").concat(white, ";\n        color: ").concat(white, ";\n      }\n    }\n  ");
}

function isLoadingStyle(baseColor, textColor) {
  var bgColor = darken(0.15, baseColor);
  return "\n    background-color: ".concat(bgColor, ";\n    border-color: ").concat(bgColor, ";\n    color: ").concat(textColor, ";\n    cursor: not-allowed;\n    &:focus {\n      ").concat(boxShadow(baseColor), "\n      text-decoration: none;\n      outline: 0;\n    }\n  ");
}

function disabledStyle(_ref17) {
  var variant = _ref17.variant,
      disabled = _ref17.disabled,
      styledAsLink = _ref17.styledAsLink,
      theme = _ref17.theme;
  var primaryDisabledStyle = "\n    color: ".concat(styledAsLink ? theme.color.grey70 : theme.color.white, ";\n    background-color: ").concat(theme.color.grey70, ";\n  ");
  var secondaryDisabledStyle = "\n    color: ".concat(theme.color.grey70, ";\n    border-color: ").concat(styledAsLink ? 'none' : theme.color.grey70, ";\n    background-color: ").concat(styledAsLink ? 'none' : theme.color.white, ";\n    svg {\n      fill: ").concat(theme.color.grey70, ";\n      color: ").concat(theme.color.grey70, ";\n    }\n  ");
  var style = variant === 'secondary' || variant === 'alternate' ? secondaryDisabledStyle : primaryDisabledStyle;
  return disabled && "\n      ".concat(style, "\n      &:disabled,\n      &:disabled:hover,\n      &:disabled:focus {\n        box-shadow: none;\n        text-decoration: none;\n        cursor: not-allowed;\n      }\n    ");
}